import api from '@/services/Api'

function formatCollectDate(collectDate) {
  const year = collectDate.getFullYear()
  const month = (collectDate.getMonth() + 1).toString().padStart(2, '0')
  const day = collectDate.getDate().toString().padStart(2, '0')

  return `${year}-${month}-${day}`
}

class ChronopostService {
  async getConstraints(repairFileId) {
    const url = '/distributor/transporter/chronopost/constraints/' + repairFileId
    const response = await api.get(url)
    return response.data
  }

  async checkFeasibility(repairFileId, collectDate) {
    const url = '/distributor/transporter/chronopost/check-feasibility'

    const data = {
      repair_file_id: repairFileId,
      collect_date: formatCollectDate(collectDate)
    }

    const response = await api.post(url, data)
    return response.data
  }

  async generateShipment(repairFileId, collectDate, service_code, withCollect) {
    const url = '/distributor/transporter/chronopost/generate-shipment'

    const data = {
      repair_file_id: repairFileId,
      collect_date: formatCollectDate(collectDate),
      service_code: service_code,
      with_collect: withCollect
    }

    const response = await api.post(url, data)
    return response.data
  }
}

export default new ChronopostService()
